import crypto from 'crypto'


function qr_encrypt(text, key, iv){
  var cipher = crypto.createCipheriv('aes-256-cbc',key,iv)
  var crypted = cipher.update(text,'utf-8',"base64")
  crypted += cipher.final("base64");
  return crypted;
}

function qr_decrypt(text, key, iv) {
  var cipher = crypto.createDecipheriv('aes-256-cbc',key,iv)
  var crypted = cipher.update(text, "base64", "utf-8")
  crypted += cipher.final("utf-8");
  return crypted;
}


document.addEventListener("DOMContentLoaded", function() {
  const element = document.getElementById('js_decode')

  if (element) {

    const text = element.dataset.qrText.replace(/-/gi, "+").replace(/_/gi, "/")
    const key = element.dataset.encKey
    const iv = element.dataset.encIv

    element.innerText = qr_decrypt(text, key, iv)
  }
})
